export const articles = [
  {
    id: "article-1",
    title: "如何与伴侣开启关于性需求的真诚对话",
    summary: "许多伴侣因为羞于开口而错过了改善亲密关系的机会。本文提供循序渐进的沟通方法，帮助你与伴侣建立开放、尊重的对话氛围。",
    content: `在长期的亲密关系中，性需求的表达往往是最容易被忽视却又至关重要的一环。很多伴侣因为担心伤害对方感受，或是自己感到羞耻，而选择将真实的想法埋藏在心底。然而，正是这种回避，反而让问题在沉默中不断累积。

<strong>一、理解沟通的心理障碍</strong>

首先，我们需要理解为什么谈论性需求如此困难。中国传统文化中对"性"话题的禁忌，让许多人从小就缺乏表达性需求的词汇和勇气。加上对"完美关系"的期待——认为真正相爱的两个人应该心有灵犀——使得开口谈论变得格外艰难。

<strong>二、选择合适的时机和场合</strong>

不要在争吵时或疲惫时提出敏感话题。选择一个双方都放松的时间，比如周末午后的一杯茶，或是散步时的自然对话。避免在卧室里严肃地"谈话"，因为这会给空间带来压力感。

<strong>三、使用"我感受"而非"你不对"的表达方式</strong>

说"我最近感觉到我们在亲密方面有些距离，我很想念那种连接的感觉"，而不是"你最近都不愿意碰我了"。前一种表达传递的是脆弱和渴望，后一种则是指责。

<strong>四、从小处开始，循序渐进</strong>

不必一开始就摊开所有问题。可以从一个简单的请求开始，比如"我希望我们能有更多的拥抱和亲吻"，然后慢慢深入到更深层的需求。

<strong>五、倾听比表达更重要</strong>

当伴侣开始回应时，请保持开放的态度，不要急于辩护或解释。真正的沟通是双向的，理解和接纳对方的感受同样重要。

<strong>六、必要时寻求专业帮助</strong>

如果自行沟通始终无法突破，考虑预约专业的性咨询顾问。有时候，有一个中立的第三方引导对话，能起到意想不到的效果。

性需求的表达不是一场谈判，而是一次彼此靠近的旅程。每一步的坦诚，都是在为关系注入新的生命力。`,
    category: "qin-mi-guan-xi-zhi-dao",
    author: "林婉清",
    authorTitle: "国家二级心理咨询师 | 性治疗师",
    publishDate: "2026-07-28",
    readTime: "8分钟",
    imageSeq: "article-intimate-talk",
  },
  {
    id: "article-2",
    title: "男性勃起功能障碍：这不是你的错，也不需要独自面对",
    summary: "ED影响着各年龄段的男性，但它并非不可治疗。了解成因、破除误区，是走向康复的第一步。",
    content: `勃起功能障碍（ED）是男性最常见的性功能问题之一，但同时也是最容易被误解和污名化的健康议题。

<strong>一、ED比你想象的更普遍</strong>

数据显示，40岁以上的男性中约有40%存在不同程度的勃起问题，而在所有年龄段的男性中，几乎每个人都可能在某个时期经历过暂时的勃起困难。这不是"少数人的问题"，而是普遍的男性健康议题。

<strong>二、心理因素与生理因素同样重要</strong>

很多人认为ED纯粹是生理问题，但实际上心理因素占据很大比例。工作压力、焦虑情绪、关系紧张、对表现的过度关注，都可能成为导火索。有时候，一次偶然的失败经历带来的心理阴影，比任何生理原因都更难克服。

<strong>三、正确认识"晨勃"的意义</strong>

晨勃的存在或缺失，是判断ED属于心理性还是器质性的重要参考。如果晨勃正常，但在伴侣互动中出现困难，大概率是心理因素所致。这一简单的自我观察，可以为后续的咨询提供重要方向。

<strong>四、生活方式的调整是基础</strong>

规律运动、健康饮食、充足睡眠、戒烟限酒——这些看似老生常谈的建议，对于改善勃起功能有着实实在在的效果。尤其是中等强度的有氧运动，能够显著改善血管内皮功能。

<strong>五、专业咨询不是"最后的选择"</strong>

很多男性将寻求帮助视为"走投无路"的选择，但实际上，越早寻求专业指导，康复的路径越短。性咨询顾问能够帮助你理清问题的根源，制定个性化的改善方案。

<strong>六、伴侣的理解是最好的良药</strong>

伴侣的态度对康复至关重要。责备和催促只会加重心理负担，理解和陪伴则是最有效的支持。专业的性咨询顾问通常也会邀请伴侣参与部分咨询环节。

不必独自面对。迈出寻求帮助的第一步，就已经在走向康复的路上。`,
    category: "xing-gong-neng-kun-rao",
    author: "陈博文",
    authorTitle: "医学博士 | 男科与性医学专家",
    publishDate: "2026-07-25",
    readTime: "10分钟",
    imageSeq: "article-ed-awareness",
  },
  {
    id: "article-3",
    title: "女性性欲低下：被忽视的两性健康议题",
    summary: "女性性欲低下（HSDD）是最常见的女性性功能障碍，但绝大多数女性从未得到过专业的帮助。",
    content: `女性性欲低下（Hypoactive Sexual Desire Disorder, HSDD）影响着约10%至15%的成年女性，但只有极少数人会主动寻求帮助。

<strong>一、这不是"性冷淡"那么简单</strong>

"性冷淡"是一个过于笼统且带有污名化的标签。女性性欲低下可能源于激素水平变化、压力累积、关系质量下降、身体形象不满或过往创伤经历等多种因素。简单粗暴的标签只会让女性更加封闭自己。

<strong>二、激素变化是真实存在的生理因素</strong>

产后、哺乳期、围绝经期等阶段的激素剧烈变化，直接影响着女性的性欲水平。这不是"不爱了"的信号，而是身体在经历自然的生理调整。

<strong>三、"心理负荷"是一个关键概念</strong>

现代女性往往身兼多重角色——职业女性、母亲、妻子、女儿。当大脑被无尽的待办事项占据时，性欲自然会被排在优先级的末尾。减轻心理负荷，比任何"技巧"都更有效。

<strong>四、与伴侣的关系质量是核心变量</strong>

研究表明，女性性欲与关系满意度高度相关。情感上的安全感和被珍惜的感觉，是女性性欲最重要的土壤。改善沟通、增加非性亲密接触的频率，往往能带来意想不到的变化。

<strong>五、重新定义"正常"</strong>

社会媒体和影视作品塑造了关于"正常"性欲的虚假标准。实际上，性欲水平存在巨大的个体差异，而且会因为生活阶段的不同而波动。重要的是找到属于自己的节奏和满意度标准。

<strong>六、专业帮助的形式多样</strong>

从个体心理咨询、伴侣联合治疗，到医学评估和生活方式干预，专业的性咨询服务提供多种可能。总有一种方式适合你。

爱自己，包括爱护自己的身体和欲望。勇敢地正视这个问题，是给自己最好的礼物。`,
    category: "xing-gong-neng-kun-rao",
    author: "林婉清",
    authorTitle: "国家二级心理咨询师 | 性治疗师",
    publishDate: "2026-07-22",
    readTime: "9分钟",
    imageSeq: "article-female-desire",
  },
  {
    id: "article-4",
    title: "青春期性教育：家长如何与孩子谈「性」不尴尬",
    summary: "很多家长想对孩子进行性教育却不知如何开口。本文分享实用的沟通策略，让性教育变得自然而顺畅。",
    content: `"妈妈，我是从哪里来的？"——这个看似简单的问题，往往让许多中国家长措手不及。青春期性教育不是一次性的"谈话"，而是一场持续的陪伴和引导。

<strong>一、从小开始，而非等到青春期</strong>

性教育应该是一个循序渐进的过程，从幼儿时期认识身体部位开始，到小学阶段了解基本的生理知识，再到青春期全面理解性健康。越早建立自然的对话习惯，越不容易在关键时期出现沟通困难。

<strong>二、利用"可教时刻"</strong>

生活中充满了自然的教育机会：电视剧中的情节、朋友家新生的小宝宝、甚至一条关于青春期的新闻。抓住这些自然出现的"可教时刻"，比专门坐下来"郑重其事的谈话"效果好得多。

<strong>三、用正确的名称称呼身体部位</strong>

使用"阴茎"、"阴道"等准确词汇而非含糊的替代说法，传递的是对身体和性的尊重态度。这也能帮助孩子在万一遇到不当触碰时，能够准确地描述和报告。

<strong>四、不只谈"风险"，更要谈"美好"</strong>

很多家长只强调性行为的风险——怀孕、疾病、伤害——却忽略了传递性在亲密关系中的美好意义。一个只被教导"性很危险"的年轻人，未来很难建立健康的亲密关系观念。

<strong>五、承认自己的不完美</strong>

如果你觉得尴尬，可以坦白告诉孩子："这个话题让我有点不好意思，但我觉得它很重要，所以我想和你聊聊。"这种坦诚反而能建立信任。孩子不需要一个"完美的专家"，他们需要一个真实的、愿意陪伴的家长。

<strong>六、价值观的传递比知识的传递更重要</strong>

网络上不缺乏"知识"，缺乏的是健康的价值观引导。尊重、责任、相互理解——这些核心价值观是任何性教育的基础。

<strong>七、知道何时寻求帮助</strong>

如果发现孩子有超出家长能力范围的问题，如性别认同困惑、疑似遭受性侵害的迹象等，请毫不犹豫地寻求专业心理咨询师的帮助。

陪伴孩子走过青春期，是一次共同成长的旅程。你在其中学会的，可能比你教给孩子的还要多。`,
    category: "qing-chun-qi-xing-jiao-yu",
    author: "苏雨桐",
    authorTitle: "青少年心理发展专家 | 家庭治疗师",
    publishDate: "2026-07-20",
    readTime: "11分钟",
    imageSeq: "article-teen-education",
  },
  {
    id: "article-5",
    title: "性的焦虑：为什么我们越想表现好，越容易失败",
    summary: "性表现焦虑是导致多种性功能障碍的核心心理因素。理解其机制，是打破恶性循环的关键。",
    content: `在性咨询室中，最常见的来访者困扰并非某种特定的功能障碍，而是一个普遍存在却鲜有人谈论的心理状态——性表现焦虑。

<strong>一、什么是性表现焦虑？</strong>

性表现焦虑是指个体在性活动中过度关注自己的"表现"，担心自己不够好、不够持久、不够有吸引力，这种焦虑本身反而干扰了自然的性反应。

<strong>二、焦虑如何扼杀欲望和功能？</strong>

从生理角度看，焦虑激活了交感神经系统——这是应对危险的"战斗或逃跑"系统。而性唤起需要的是副交感神经系统的参与，即"放松和享受"模式。两个系统相互拮抗，焦虑越多，唤起越难。

<strong>三、"旁观者视角"的陷阱</strong>

表现焦虑的核心特征之一是从"参与者"变成了"旁观者"——你在脑海中看着自己，评价自己。这种自我监控和评判，让自然的性反应链条被打断，性变成了"表演"而非"体验"。

<strong>四、社会文化如何加剧焦虑？</strong>

影视作品和社会叙事塑造了不切实际的"完美性爱"标准：男性应该永远坚挺持久，女性应该总是热情高涨。当现实与这些虚构标准冲突时，焦虑和挫败感就随之而来。

<strong>五、打破焦虑循环的实践方法</strong>

正念练习是应对表现焦虑的有效工具。学会将注意力从"评价表现"转向"感受当下"，是重建自然性反应的关键一步。深呼吸、感官聚焦练习、渐进式肌肉放松，都是可以在日常生活中练习的技能。

<strong>六、与伴侣分享你的焦虑</strong>

很多来访者独自承受着巨大的心理压力，而伴侣完全不知情。当你鼓起勇气分享时，往往发现伴侣的反应比想象中温和得多。一起面对，焦虑的重量就减了一半。

<strong>七、专业帮助不是失败，而是智慧</strong>

认知行为疗法（CBT）和正念性治疗在改善表现焦虑方面有着扎实的研究支持。寻求专业帮助不是"搞不定"的证明，而是对自己和伴侣关系负责的智慧选择。

放下"完美表现"的包袱，回归到两个人之间的真实连接和感受——这才是亲密关系的本质。`,
    category: "xing-xin-li-jian-kang",
    author: "陈博文",
    authorTitle: "医学博士 | 男科与性医学专家",
    publishDate: "2026-07-18",
    readTime: "7分钟",
    imageSeq: "article-performance-anxiety",
  },
  {
    id: "article-6",
    title: "婚姻中的「无性」困境：如何重新点燃亲密火花",
    summary: "长期无性婚姻比人们想象的更普遍。本文探讨其成因、影响以及可行的改善路径。",
    content: `"无性婚姻"通常被定义为每年性生活少于10次的婚姻关系。研究表明，约有15%至20%的已婚夫妇处于这种状态。这不是少数人的困境。

<strong>一、"无性"不等于"无爱"</strong>

首先需要澄清的是，许多无性婚姻中的夫妇仍然深爱彼此。问题的根源往往不在于爱的缺失，而在于生活压力、育儿消耗、健康问题、关系动力等因素共同作用，让性的优先级不断后移。

<strong>二、常见的成因分析</strong>

育儿期间的极端疲劳、长期未解决的矛盾积累、对不同性需求频率的磨合失败、中年危机的冲击、身体形象变化带来的不自信——每一种因素都可能是压垮性生活的最后一根稻草。

<strong>三、沉默的代价</strong>

大多数面临这一困境的夫妇选择避而不谈，因为话题太敏感、太容易引发争吵。然而沉默的代价是巨大的：情感的疏远、自尊的侵蚀、出轨风险的增加，甚至婚姻的解体。

<strong>四、"非性亲密"的重建</strong>

在重新尝试性生活之前，首先需要重建非性的亲密连接。拥抱、牵手、依偎着看电影、真诚的赞美、深度的交谈——这些看似"小事"的日常亲密，是性亲密最重要的养料。

<strong>五、从"期待"到"预约"的转变</strong>

一个实用的建议是，不要等待"感觉来了"的完美时刻（它几乎从不自然降临在忙碌的婚姻生活中）。相反，可以约定固定的亲密时间，给彼此创造一个放松、无压力的空间。

<strong>六、放下对"数量"的执念</strong>

社会对"正常"频率的强调制造了不必要的焦虑。一对夫妇的"正常"与另一对没有可比性。重要的是双方都能接受的满意程度，而非某个外在的数字标准。

<strong>七、婚姻咨询师的力量</strong>

专业的伴侣性咨询能够帮助夫妇打破僵局，因为咨询师提供了安全的第三方空间，让双方能够说出平时难以启齿的真实想法。许多看似无解的关系困境，在专业引导下找到了出口。

婚姻中的性是脆弱而珍贵的存在。它不是关系的全部，却是关系中不容忽视的重要部分。`,
    category: "hun-yin-jia-ting-zi-xun",
    author: "苏雨桐",
    authorTitle: "青少年心理发展专家 | 家庭治疗师",
    publishDate: "2026-07-15",
    readTime: "12分钟",
    imageSeq: "article-marriage-intimacy",
  },
  {
    id: "article-7",
    title: "性传播疾病预防：知识是最好的保护",
    summary: "了解常见性传播疾病的预防、检测和治疗知识，是保护自己和伴侣健康的重要一步。",
    content: `性传播疾病（STDs）的预防意识和知识，是每个人性健康教育中不可或缺的一部分。

<strong>一、常见的性传播疾病一览</strong>

了解常见的STDs包括衣原体感染、淋病、梅毒、生殖器疱疹、人类乳头瘤病毒（HPV）、HIV等。每种疾病的传播途径、症状表现和治疗方法各不相同，但都有一个共同点：早发现、早治疗。

<strong>二、预防措施的科学认知</strong>

安全套是目前最有效的STDs预防工具之一，但需要正确和持续使用。HPV疫苗接种是预防宫颈癌和相关疾病的重要手段。定期检测则是性活跃人群的基本健康习惯。

<strong>三、打破污名化</strong>

感染STDs不是"道德污点"，它和其他任何疾病一样，是一个需要面对的医疗问题。社会对STDs的污名化，反而阻碍了人们寻求检测和治疗的意愿，造成了更大的公共卫生风险。

<strong>四、伴侣沟通的技巧</strong>

如何与伴侣谈论检测历史和性健康？关键在于以关心双方健康而非"不信任对方"的态度来表达。使用"我们一起去检测，是对彼此负责任的做法"这样的表述，能够减少对方的防备心理。

<strong>五、检测和治疗资源的获取</strong>

各地疾控中心、正规医院皮肤科或性病科、以及部分社区健康中心，都提供保密的STDs检测服务。请避免在非正规机构进行检测和治疗。

<strong>六、感染后的心理调适</strong>

如果确诊感染，首先要做的是按照医嘱规范治疗，同时关注自己的心理健康。许多人感染后经历羞耻、恐惧、焦虑等情绪——请记住，你的价值不会因为一个医疗诊断而改变。必要时寻求心理咨询的帮助。

知识是消除恐惧的最好方式。了解得越多，保护自己和伴侣的能力就越强。`,
    category: "xing-jian-kang-jiao-yu",
    author: "陈博文",
    authorTitle: "医学博士 | 男科与性医学专家",
    publishDate: "2026-07-12",
    readTime: "9分钟",
    imageSeq: "article-std-prevention",
  },
  {
    id: "article-8",
    title: "自慰与健康：打破迷思，拥抱科学的自我认知",
    summary: "自慰是正常的性行为之一，但围绕它的迷思和罪恶感仍在困扰着许多人。让我们用科学的态度重新认识它。",
    content: `在众多性健康话题中，自慰可能是被讨论得最多却也最缺乏科学认知的话题之一。

<strong>一、自慰的普遍性</strong>

大规模调查显示，绝大多数男性和相当比例的女性在一生中的某个阶段有过自慰行为。从发展心理学的角度看，自慰是性心理发展的自然组成部分。

<strong>二、科学证实的健康益处</strong>

适度的自慰有助于缓解性紧张、改善睡眠质量、减轻压力、帮助了解自己的身体和性偏好。对女性而言，自慰与更好的性满意度和更容易达到高潮相关。

<strong>三、需要警惕的误区</strong>

"自慰会导致阳痿"、"自慰会影响生育能力"、"自慰是道德败坏的表现"——这些流传广泛的迷思没有科学依据。适度的自慰不会对身体造成损害，也不会影响正常的性功能。

<strong>四、什么是"适度"？</strong>

"适度"没有一个放之四海而皆准的标准。关键在于：它是否干扰了你的日常生活、工作和人际关系？如果自慰变成了逃避现实问题的方式，或者伴随强烈的羞耻和罪恶感，那么可能需要重新审视这种行为的心理意义。

<strong>五、文化背景的影响</strong>

在许多传统文化中，自慰被赋予了强烈的道德评判。这些价值观的内化，让很多人即便在理性上知道自慰无害，仍然在情感上感到内疚。理解并和解这些文化背景带来的心理烙印，是性心理健康的重要一步。

<strong>六、伴侣关系中的自慰</strong>

有伴侣的人也会自慰，这并不代表伴侣关系出现了问题。在健康的关系中，自慰和伴侣性爱是互补而非竞争的关系。坦诚地与伴侣沟通这一话题，可以增进相互的理解和信任。

<strong>七、何时需要专业帮助？</strong>

如果自慰行为达到强迫性的程度，或者伴随强烈的心理痛苦，或者采用可能造成身体伤害的方式，建议寻求专业的性心理咨询。

对身体的探索和认知，是每个人与生俱来的权利。用科学理性的态度取代道德评判，是走向性心理健康的重要一步。`,
    category: "xing-jian-kang-jiao-yu",
    author: "林婉清",
    authorTitle: "国家二级心理咨询师 | 性治疗师",
    publishDate: "2026-07-10",
    readTime: "11分钟",
    imageSeq: "article-masturbation-health",
  },
  {
    id: "article-9",
    title: "分手后如何重建自我：从心碎到成长的旅程",
    summary: "一段亲密关系的结束往往伴随着深刻的痛苦。本文提供心理学视角的恢复路径，帮助你在心碎中找到成长的力量。",
    content: `亲密关系的结束，是人生中最痛苦的经历之一。但这种痛苦中，也蕴含着深刻的成长机会。

<strong>一、允许自己悲伤</strong>

分手后的悲伤是正常且必要的。否认、愤怒、讨价还价、抑郁、接受——这些情感阶段不必按照固定顺序经历，每个人的恢复节奏都不一样。重要的是，不要因为"已经过了这么久"而责备自己。

<strong>二、理解依恋断裂的生理基础</strong>

研究表明，分手所激活的大脑区域与身体疼痛相同。你的痛苦不只是"心理上的"，它是真实的生理反应。理解这一点，能帮助你以更温和的态度对待自己。

<strong>三、避免陷入"复盘陷阱"</strong>

不断在脑海中回放关系中的每一个细节，分析"到底哪里出了问题"——这种"复盘"行为虽然在短期内给人掌控感，但长期来看只会延长痛苦。适时的"放下追问"是一种智慧。

<strong>四、重建独立的自我身份</strong>

在长期关系中，两个人的身份往往会融合。分手后需要重新找到"我是谁"的独立答案。探索新的兴趣、重拾旧日的爱好、建立属于自己的社交圈——这些行动都在帮助重建独立的自我。

<strong>五、管理社交媒体带来的额外伤害</strong>

看到前任的动态、共同朋友的更新，都可能成为恢复路上的绊脚石。在恢复初期，考虑暂时"静音"或"取关"相关的社交账号，给自己创造一个安全的情感空间。

<strong>六、什么才是"准备好"开始新的关系？</strong>

真正的"准备好"不是完全忘记了前任，而是你不再需要一段新关系来证明自己的价值。当你能够完整地独处，新关系才会是锦上添花，而非救命稻草。

<strong>七、专业心理咨询的价值</strong>

如果分手后的情绪困扰持续数周甚至数月，严重影响到日常生活功能，专业的心理咨询可能是最有效的支持。不要独自承担所有痛苦。

每一次心碎都是一次蜕变的开始。当你走出这段黑暗，会发现一个比从前更加完整、更加了解自己的你。`,
    category: "xing-xin-li-jian-kang",
    author: "林婉清",
    authorTitle: "国家二级心理咨询师 | 性治疗师",
    publishDate: "2026-07-08",
    readTime: "10分钟",
    imageSeq: "article-heartbreak-recovery",
  },
];